export default "__VITE_ASSET__DxjLvjRf__"